import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";


// GET REQUISAS DE COMBUSTIBLE PENDIENTES DE AUTORIZAR
export const getRequisasCombusPendientesAutorizar = async (permiso, data) => {
    const result = await PrivateInterceptor(`Logistica/RequisaCombustible/getPendienteAutorizar/${permiso}`, 'POST', {...data, web: 1})
    return result;
  };
  
  
  // GET REQUISAS DE COMBUSTIBLE PENDIENTES DE AUTORIZAR
  export const getRequisaCombustible = async (IdRequisaDetalles) => {
    const result = await PrivateInterceptor(`Logistica/RequisaCombustible/getRequisaCombustible`, 'POST', IdRequisaDetalles)
    return result;
  };

  export const getRequisasNuevas = async() => {
     const result = await PrivateInterceptor(`Logistica/RequisaCombustible/getRequisasNuevas`, 'POST');
     return result;
  }
  
  
  export const changePermosoRequisaCombustible = async (data) => {
    const result = await PrivateInterceptor(`Logistica/RequisaCombustible/changePermiso`, 'POST', data)
    return result;
  };
  
  